import { ApiQueryParams } from '@frontend/api-utils';
import { IoT, IoTQueryParams } from '@frontend/iot/types';
import { useState } from 'react';

export interface MultiIoTSelectProps {
    id?: string;
    label?: React.ReactNode;
    required?: boolean;
    onChange?: (newValue: string[]) => void;
    onChangeObject?: (newValue: IoT[]) => void;
    value?: string[];
    className?: string;
    disabled?: boolean;
    isClearable?: boolean;
    queryParams?: ApiQueryParams<IoTQueryParams>;
    helpMessage?: React.ReactNode;
}

interface ViewProps {
    value: IoT[] | null;
    changeValue: (value: IoT[]) => void;
}

const useMultiIoTSelect = (props: MultiIoTSelectProps): ViewProps => {
    const [value, changeValue] = useState<IoT[] | null>(null);

    return {
        value,
        changeValue
    };
};

export default useMultiIoTSelect;
